import { Subject } from 'rxjs'
import { Component, Output } from '@angular/core'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'simple-modal',
    templateUrl: './simple-modal.component.html',
    styleUrls: ['./simple-modal.scss'],
})
export class SimpleModal {
    constructor(private activeModal: NgbActiveModal) {}

    firstText =
        'Para realizar o cancelamento do cadastro e retirada do último terminal, favor entrar em contato com o time Sou Parceiro para prosseguir com a demanda. '
    secondText = 'O contato deverá ser feito através do canal souparceiro@stone.com.br '

    closeModal() {
        this.activeModal.close({
            confirmation: false,
        })
    }
}
